module.exports = __webpack_public_path__ + "static/media/fullmoon-box.4b58a0f4.png";